const defaults = {
  clamp: true,
  precision: 0.001,
};

const springConfigs = {
  bounceback: {
    mass: 100,
    tension: 100,
    friction: 10,
    velocity: -0.05,
    ...defaults,
  },
  outlineAppear: {
    mass: 1,
    tension: 70,
    friction: 40,
    ...defaults,
  },
  curtains: {
    introTransparent: {
      tension: 12,
      friction: 0,
      //   velocity: 0.01,
      clamp: true,
      ...defaults,
    },
    intro: {
      tension: 16,
      friction: 1,
      clamp: true,
      ...defaults,
    },
    outro: {
      tension: 10,
      friction: 1,
      clamp: true,
      ...defaults,
    },
  },
  assetAppears: {
    mass: 1,
    tension: 3,
    friction: 1,
    ...defaults,
  },
  textAppears: {
    mass: 1,
    tension: 45,
    ...defaults,
  },
  backgroundTransitions: {
    mass: 1,
    tension: 15,
    friction: 1,

    ...defaults,
  },
  columnInactive: {
    mass: 1,
    tension: 30,
    friction: 1,
    ...defaults,
  },
};

export { springConfigs };
